/**
 * angular-admin-oskey-io
 *
 * @license
 * Copyright (c) 2021-2025, OSKEY SAS. All rights reserved.
 *
 * The source code is protected under international copyright law.
 * All rights reserved and protected by the copyright holders.
 *
 * The source code is confidential and only available to authorized individuals with the permission of the copyright holders.
 * If you encounter this source code and do not have permission, please contact the copyright holders and delete this file.
 */

import { Injectable, inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { OSKTranslateService } from '@oskey/translate';

@Injectable({
  providedIn: 'root'
})
export class OSKErrorService {
  private readonly snackBar: MatSnackBar = inject(MatSnackBar);
  private readonly translate: OSKTranslateService = inject(OSKTranslateService);
  private readonly errorsPrefix: string = 'errors.';
  private readonly defaultErrorMsg: string = this.translate.instant('errors.default');

  /**
   * Shows a snackbar toast with specific error message.
   * If a translation key is not provided, the default error message is shown.
   *
   * @param { string | undefined } msgTranslationKey The translation key for the error message.
   */
  showError(msgTranslationKey?: string): void {
    let msg = msgTranslationKey ? this.translate.instant(msgTranslationKey) : this.defaultErrorMsg;
    if (msg === msgTranslationKey) {
      msg = this.defaultErrorMsg;
    }

    this.snackBar.open(this.translate.instant(msg), 'OK', {
      horizontalPosition: 'center',
      verticalPosition: 'top'
    });
  }
}
